import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { PainSection } from './components/PainSection';
import { SolutionSection } from './components/SolutionSection';
import { RecipeGallerySection } from './components/RecipeGallerySection';
import { BonusSection } from './components/BonusSection';
import { SavingsSection } from './components/SavingsSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { OfferSection } from './components/OfferSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FaqSection } from './components/FaqSection';
import { PurchasePopup } from './components/PurchasePopup';
import { Footer } from './components/Footer';
import { CtaButton } from './components/CtaButton';
import { initializeMetaPixel } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    initializeMetaPixel();
  }, []);
  return <div className="w-full min-h-full bg-white font-sans text-neutral-900 antialiased" data-id="element-0" data-mp="23ujmchww7x65">
      <Hero data-id="element-1" data-mp="3iiwf2oflbi38" />
      <PainSection data-id="element-2" data-mp="3ij61k21ff746" />
      <SolutionSection data-id="element-3" data-mp="3ihv22ef0kliv" />
      <RecipeGallerySection data-id="element-4" data-mp="3mlj8uuvtnd32" />
      <BonusSection data-id="element-5" data-mp="3mkrgdsxitvh0" />
      <SavingsSection data-id="element-6" data-mp="3mjzsl4a6121a" />
      <TestimonialsSection data-id="element-7" data-mp="3mjg93j4va5l5" />
      <OfferSection data-id="element-8" data-mp="3rcj8i7wbs999" />
      <GuaranteeSection data-id="element-9" data-mp="3rbzpsoyupgu6" />
      <FaqSection data-id="element-10" data-mp="3rcswxr1q28cu" />

      {/* CTA final de cierre */}
      <section className="w-full bg-green-600 py-10 sm:py-14" data-id="element-11" data-mp="6hrlipoilfp">
        <div className="mx-auto max-w-2xl px-4 text-center sm:px-6" data-id="element-12" data-mp="82j0zgp5o9c">
          <h2 className="text-2xl font-black leading-tight text-white sm:text-3xl" data-id="element-13" data-mp="2zmemk4sx3e5x">
            Tu Air Fryer está esperando. Empezá a comer como en un bodegón hoy mismo.
          </h2>
          <p className="mt-3 text-green-50" data-id="element-14" data-mp="38kqb81a841vq">
            250 recetas + 5 bonos por un único pago de $14.900.
          </p>
          <div className="mt-8 rounded-2xl bg-white p-4" data-id="element-15" data-mp="3dmfn1j59sjkv">
            <CtaButton data-id="element-16" data-mp="nw2e2bl1k0tq" />
          </div>
        </div>
      </section>

      <Footer data-id="element-17" data-mp="nxx0jubyo0zx" />
      <PurchasePopup data-id="element-18" data-mp="sudmqizlo5ad" />
    </div>;
}